module.exports = __webpack_public_path__ + "img/18-presentation.91a0df4f.jpg";